import { useEffect } from 'react'
import { Input, Modal, Form, InputNumber } from 'antd'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../hooks'
import { GLOBAL_CLIENT } from '../../helpers/GlobalClient'
import { useTranslation } from 'react-i18next'
import { debounce, trim } from 'lodash'

const formItemLayout = {
   labelCol: {
      xs: { span: 24 },
      sm: { span: 8 }
   },
   wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 }
   }
}

const ProductTypeDetail = observer((props: any) => {
   const { t } = useTranslation()

   const CommonConfigStore = useStore('CommonConfigStore')
   const { visible, onOk, onCancel, item } = props

   const [form] = Form.useForm()
   useEffect(() => {}, [])

   const onFinish = async (values: any) => {
      // console.log('Received values of form: ', values)
      const result = await CommonConfigStore.editTag(
         item?.id,
         trim(values?.name) || ''
         // trim(values?.index) || ''
      )
      if (result) {
         form.resetFields()
         onOk()
      }
   }

   return (
      <Modal
         width={'68%'}
         visible={visible}
         centered
         title={t(GLOBAL_CLIENT.detail)}
         okText={t(GLOBAL_CLIENT.edit)}
         cancelText={t(GLOBAL_CLIENT.huy)}
         onCancel={onCancel}
         onOk={form.submit}
      >
         <Form {...formItemLayout} form={form} name="create" onFinish={debounce(onFinish, 400)} scrollToFirstError>
            <Form.Item
               name="name"
               label={t(GLOBAL_CLIENT.tag)}
               initialValue={item?.name}
               rules={[
                  {
                     required: true,
                     message: 'Vui lòng nhập tag'
                  },
                  ({ getFieldValue }) => ({
                     validator(_, value) {
                        if (trim(value) !== '') {
                           return Promise.resolve()
                        }
                        return Promise.reject(t(GLOBAL_CLIENT.noTrim))
                     }
                  })
               ]}
            >
               <Input maxLength={20} />
            </Form.Item>
            {/* <Form.Item name="index" initialValue={item?.index} label={t(GLOBAL_CLIENT.thutu)}>
               <InputNumber maxLength={8} min={0} max={1000000} step={1} />
            </Form.Item> */}
         </Form>
      </Modal>
   )
})

export default ProductTypeDetail
